module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale_bg-c75d6bf5dbc83cbaa84ff219c4f5c5c9.jpg";